<template>
    <div>
        <buttonlist
                @help="help"
                @opentable="opentable"
                @add="add"
                @search="search"
                @reflash="reflash"
                @exps="exps"
                @del="del"
                @imp='imp'
                ref="SetBtn"
        ></buttonlist>
        <div style="margin-top: 2px">
            <el-button type="primary" size="mini" @click="createVenderRFQ" :disabled="selectData.length == 0">{{$t('getapi[12765]')}}</el-button>
            <el-button type="primary" size="mini" @click="upFRQQT">{{ $t('getapi[12957]') }}</el-button>
            <el-button type="primary" size="mini" @click="setEffectTime">{{ $t('getapi[13515]') }}</el-button>
        </div>
        <wTable
                id="xpane-0"
                :data="dataSet"
                :loading="loading"
                queryData="FrmRFQPart"
                :filter_language="['part_status']"
                :filter_thousandth="['part_qty','part_year_qty']"
                :filter_date="['part_require_date']"
                :header="tableHeader"
                :option="tableOption"
                @handleSelectionChange="handleSelectionChange"
                ref="singleTable"
                @lct="editInfo"
                :authority="!btn.edit"
        ></wTable>
        <!--<el-table
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                @selection-change="handleSelectionChange"
                style="width: 100%; margin-top:0px"
                :header-cell-style="$limits.headerClass"
        >
            <el-table-column type="selection"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_file" :label="$t('getapi[7884]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_require_date" :label="$t('getapi[7889]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_status" :label="$t('getapi[7919]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_question" :label="$t('getapi[7920]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_reply" :label="$t('getapi[7901]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_blueprint_code" :label="$t('getapi[7885]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_page" :label="$t('getapi[7896]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_description" :label="$t('getapi[196]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_qty" :label="$t('getapi[4287]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_item_type" :label="$t('getapi[4241]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_year_qty" :label="$t('getapi[7897]')" align="right"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_unit" :label="$t('getapi[727]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_avl_text" :label="$t('getapi[7898]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_avl_code" :label="$t('getapi[7899]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_remark" :label="$t('getapi[7903]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="part_create_date" :label="$t('getapi[7921]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="create_person" :label="$t('getapi[410]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="create_time" :label="$t('getapi[409]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="modify_person" :label="$t('getapi[733]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="modify_time" :label="$t('getapi[734]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="close_person" :label="$t('getapi[2356]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="close_time" :label="$t('getapi[2358]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_type_id" :label="$t('getapi[3137]')"></el-table-column>
            <el-table-column show-overflow-tooltip fixed="right"  :label="$t('getapi[6048]')" width="60">
                <template slot-scope="scope" >
                    <el-button :disabled="!btn.edit" @click.native.prevent="editInfo(scope)"  type="text" size="mini">{{ $t('getapi[34]') }}</el-button>
                </template>
            </el-table-column>
        </el-table>-->
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames }}</div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="FrmRFQPart" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[6546]')" queryData="FrmRFQPart" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>

        <el-dialog v-dialogDrag :visible.sync="isShowEdit" :title="$t('getapi[34]')" width="50%" :close-on-click-modal="false">
            <el-divider></el-divider>
            <div :style="{border:'1px solid #DCDFE6'}">
                <table>
                    <tr>
                        <td>{{$t('getapi[7884]')}}</td>
                        <td><el-input v-model="dataDetail.part_file"></el-input></td>
                        <td>{{$t('getapi[7889]')}}</td>
                        <td><el-date-picker v-model="dataDetail.part_require_date" type="date" size="mini"
                                            style="width:100%"></el-date-picker></td>
                        <td>{{$t('getapi[7919]')}}</td>
                        <td>
                            <el-input v-model="dataDetail.part_status" :disabled="true"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[7920]')}}</td>
                        <td><el-input v-model="dataDetail.part_question"></el-input></td>
                        <td>{{$t('getapi[7901]')}}</td>
                        <td><el-input v-model="dataDetail.part_reply"></el-input></td>
                        <td>{{$t('getapi[7885]')}}</td>
                        <td><el-input v-model="dataDetail.part_blueprint_code"></el-input></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[7896]')}}</td>
                        <td><el-input v-model="dataDetail.part_page"></el-input></td>
                        <td>{{$t('getapi[196]')}}</td>
                        <td><el-input v-model="dataDetail.part_description"></el-input></td>
                        <td>{{$t('getapi[4287]')}}</td>
                        <td><el-input v-model="dataDetail.part_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[4241]')}}</td>
                        <td><el-input v-model="dataDetail.part_item_type"></el-input></td>
                        <td>{{$t('getapi[7897]')}}</td>
                        <td><el-input v-model="dataDetail.part_year_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent></el-input></td>
                        <td>{{$t('getapi[727]')}}</td>
                        <td><el-input v-model="dataDetail.part_unit"></el-input></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[7898]')}}</td>
                        <td><el-input v-model="dataDetail.part_avl_text"></el-input></td>
                        <td>{{$t('getapi[7899]')}}</td>
                        <td><el-input v-model="dataDetail.part_avl_code"></el-input></td>
                        <td>{{$t('getapi[7903]')}}</td>
                        <td><el-input v-model="dataDetail.part_remark"></el-input></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[112]')}}</td>
                        <td><el-input v-model="dataDetail.part_code"></el-input></td>
                        <td>{{$t('getapi[7921]')}}</td>
                        <td><el-date-picker v-model="dataDetail.part_create_date" type="date" size="mini"
                                            style="width:100%"></el-date-picker></td>
                        <td>{{$t('getapi[410]')}}</td>
                        <td><el-input v-model="dataDetail.create_person" :disabled="true"></el-input></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[409]')}}</td>
                        <td><el-date-picker v-model="dataDetail.create_time" type="date" size="mini"
                                            style="width:100%" :disabled="true"></el-date-picker></td>
                        <td>{{$t('getapi[733]')}}</td>
                        <td><el-input v-model="dataDetail.modify_person" :disabled="true"></el-input></td>
                        <td>{{$t('getapi[734]')}}</td>
                        <td><el-date-picker v-model="dataDetail.modify_time" type="date" size="mini"
                                            style="width:100%" :disabled="true"></el-date-picker></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[2356]')}}</td>
                        <td><el-input v-model="dataDetail.close_person" :disabled="true"></el-input></td>
                        <td>{{$t('getapi[2358]')}}</td>
                        <td><el-date-picker v-model="dataDetail.close_time" type="date" size="mini"
                                            style="width:100%" :disabled="true"></el-date-picker></td>
                        <td>{{$t('getapi[3137]')}}</td>
                        <td><el-input v-model="dataDetail.exclusively_id" :disabled="true"></el-input></td>
                    </tr>
                </table>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isShowEdit = false" size="mini">{{ $t('getapi[6]') }}</el-button>
				<el-button type="primary" @click="save" :loading="loading" :disabled="loading" size="mini">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>

        <el-dialog v-dialogDrag :visible.sync="showCreateVender" :title="$t('getapi[12765]')" width="30%" :close-on-click-modal="false">
            <el-divider></el-divider>
            <div :style="{border:'1px solid #DCDFE6'}">
                <table>
                    <tr>
                        <td>{{$t('getapi[1323]')}}</td>
                        <td style="width:400px">
                            <el-input  type="text" v-model="dataVenderRFQ.Vender_Code"
                                       readonly
                                       size="mini"
                                       class="mcolor"
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectVender()"></i>
                            </el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[12688]')}}</td>
                        <td  style="width:400px"><el-input v-model="dataVenderRFQ.Vender_Email" type="text" size="mini" ></el-input></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[3139]')}}</td>
                        <td  style="width:400px">
                            <el-input  type="text" v-model="dataVenderRFQ.Manager_Person"
                                       readonly
                                       size="mini"
                                       class="mcolor"
                            >
                                <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectManager()"></i>
                            </el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[8266]')}}</td>
                        <td  style="width:400px"><el-input v-model="dataVenderRFQ.Manager_PersonEmail" type="text" size="mini" ></el-input></td>
                    </tr>
                </table>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
				<el-button @click="showCreateVender = false" size="mini">{{ $t('getapi[6]') }}</el-button>
				<el-button type="primary" @click="confirmCreateVenderRFQ" :loading="loading" :disabled="loading" size="mini">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>
        <el-dialog v-dialogDrag :visible.sync="showEffectTime" :title="$t('getapi[13515]')" width="15%" :close-on-click-modal="false">
            <el-divider></el-divider>
            <div :style="{border:'1px solid #DCDFE6'}">
                <table>
                    <tr>
                        <td>{{$t('getapi[7877]')}}</td>
                        <td><el-date-picker v-model="effectivedate" type="date" size="mini" format="yyyy-MM-dd"
                                            style="width:100%"></el-date-picker></td>
                    </tr>
                </table>
            </div>
            <el-divider></el-divider>
            <span style="color: blue">{{$t('getapi[13516]')}}</span>
            <span slot="footer" class="dialog-footer">
				<el-button @click="showEffectTime = false" size="mini">{{ $t('getapi[6]') }}</el-button>
				<el-button type="primary" @click="confirmSetEffectTime" size="mini">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>
        <selector :isVisible="false" :selectType="1" :isBatch=true :isSplitPage=true :postUrl="'/Basic/Popup/GetSupplyPopuDataList'" @callback="getVender" ref="vender"></selector>
        <selector :isVisible="false" :isBatch=false :selectType="9" :isSplitPage=true :postUrl="'/Basic/Popup/GetEmployeeDataList'" @callback="getManager" ref="manager"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    export default {
        name:'purrfqbpart',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                    maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                user: '',
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('purrfqbpart'), // 当前页数据量
                SelectIndexs: 0, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                selectData: [], //勾选合集
                dataDetail: {},
                isShowEdit: false,
                btn:{
                    edit: false
                },
                scrollTop:0,
                showCreateVender: false,
                dataVenderRFQ:{},
                showEffectTime: false,
                effectivedate:'',
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function() {
            let that = this;
            that.colsort();
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            that.effectivedate =Array.methods.getSysConfig('Purrfqbpart_EffectiveDate');
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })

        },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('FrmRFQPart', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6545]"),this.$t("getapi[17]"));
            },
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if (that.$limits.authority('plv2', 229, 1) == 1) {
                    //只读权
                    that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                }
                else if (that.$limits.authority('plv2', 229, 1) == 2) {
                    if (that.$limits.authority('plv3', 229,1) == 0) {
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    //操作权
                    if (that.$limits.authority('plv3', 229,1) == 1) {
                        that.btn.edit = true
                        //编辑级
                        that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export,import');
                    }
                    if (that.$limits.authority('plv3', 229, 1) == 2) {
                        that.btn.edit = true
                        //删除级
                        if(that.selectData.length > 0 ){
                            that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export,import,del');
                        } else {
                            that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export,import');
                        }
                    }
                }
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('purrfqbpart',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'FrmRFQPart');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Pur/RFQB/PurRFQBPartDataList', data, function(res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                });
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/Pur/RFQB/PurRFQBPartToExecl', parm, function(res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "FrmRFQPart",
                    fromname: that.$t("getapi[6545]"),
                    SelectIndex: that.SelectIndexs,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            handleSelectionChange(val){
                let that = this;
                that.selectData = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData.push(val[i]);
                }
                that.authority()
            },
            del(){
                let that = this
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let arr = []
                        for(let i = 0;i<that.selectData.length;i++){
                            arr = [...arr,{
                                exclusively_id: that.selectData[i].exclusively_id,
                                modify_time: that.selectData[i].modify_time,
                                part_status: that.selectData[i].part_status
                            }]
                        }
                        let parm = {
                            LangType: that.$processdata.getLang(),
                            list: arr
                        }
                        that.$http.urlpost('/Pur/RFQB/DelPurRFQBPart', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            editInfo(row){
                let that = this
                let parm = {
                    Id: row.row.exclusively_id
                }
                that.$http.urlpost('/Pur/RFQB/GetSchRFQPartInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.isShowEdit = true
                        that.dataDetail = res.DataContent.Head
                    }
                });
            },
            // 新增
            add() {
                let that = this;
                that.isShowEdit = true;
                that.dataDetail = {
                    exclusively_id: -1,
                    part_status: '草稿',
                    part_file: '',
                    part_require_date: '',
                    part_question: '',
                    part_reply: '',
                    part_blueprint_code: '',
                    part_page: '',
                    part_description: '',
                    part_qty: '',
                    item_type_id: '',
                    part_item_type: '',
                    part_year_qty: '',
                    part_unit: '',
                    part_avl_text: '',
                    part_avl_code: '',
                    part_remark: '',
                    part_code: '',
                    part_create_date: '',
                    create_person: that.user,
                    create_time: '',
                    modify_person: '',
                    modify_time: '',
                    audit_person: '',
                    audit_time: '',
                    close_person: '',
                    close_time: ''
                };
            },
            save(){
                let that = this
                let parm = {
                    Head: that.dataDetail
                }
                that.$http.urlpost('/Pur/RFQB/SaveData', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.isShowEdit = false
                        that.getView()
                    }
                });
            },
            imp(){
                let item = {
                    label: '通用导入',
                    name: 'exp',
                    path: '/exp/22',
                    url: '/exp/22',
                    icon: 'video-play'
                };
                this.$router.push({ path: '/exp/22' });
                this.$store.commit('selectMenu', item);
            },
            createVenderRFQ(){
                let that = this
                that.dataVenderRFQ = {
                    Vender_Code:'',
                    Vender_Email:'',
                    Manager_Person:'',
                    Manager_PersonEmail:'',
                }
                that.showCreateVender = true
            },
            confirmCreateVenderRFQ(){
                let that = this
                if(that.dataVenderRFQ.Vender_Code == '' || that.dataVenderRFQ.Manager_Person == ''){
                    that.$message.warning(that.$t('getapi[1158]'))
                    return false
                }
                let arr = []
                for(let i = 0;i<that.selectData.length;i++){
                    arr = [...arr,{
                        Exclusively_ID: that.selectData[i].exclusively_id,
                        part_STATUS: that.selectData[i].part_status,
                        part_file: that.selectData[i].part_file,
                        part_require_date: that.selectData[i].part_require_date,
                        part_question: that.selectData[i].part_question,
                        part_reply: that.selectData[i].part_reply,
                        part_BLUEPRINT_CODE: that.selectData[i].part_blueprint_code,
                        part_Page: that.selectData[i].part_page,
                        part_description: that.selectData[i].part_description,
                        part_qty: that.selectData[i].part_qty,
                        item_type_id: that.selectData[i].item_type_id,
                        part_item_type: that.selectData[i].part_item_type,
                        part_year_qty: that.selectData[i].part_year_qty,
                        part_unit: that.selectData[i].part_unit,
                        part_avl_text: that.selectData[i].part_avl_text,
                        part_avl_code: that.selectData[i].part_avl_code,
                        part_remark: that.selectData[i].part_remark,
                        part_code: that.selectData[i].part_code,
                        part_create_date: that.selectData[i].part_create_date,
                        Create_person: that.selectData[i].create_person,
                        Create_time: that.selectData[i].create_time,
                        modify_person: that.selectData[i].modify_person,
                        modify_time: that.selectData[i].modify_time,
                        audit_person: that.selectData[i].audit_person,
                        audit_time: that.selectData[i].audit_time,
                        close_person: that.selectData[i].close_person,
                        close_time: that.selectData[i].close_time
                    }]
                }
                let parm = {
                    Vender_Code:that.dataVenderRFQ.Vender_Code,
                    Vender_Email: that.dataVenderRFQ.Vender_Email,
                    Manager_Person: that.dataVenderRFQ.Manager_Person,
                    Manager_PersonEmail: that.dataVenderRFQ.Manager_PersonEmail,
                    list:arr,
                }
                that.$http.urlpost('/Pur/RFQB/CreateVenderRFQQuotation', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.showCreateVender = false
                        that.getView()
                    }
                });
            },
            selectVender(){
                let that = this;
                that.$refs.vender.clearInput(true);
            },
            getVender(data){
                let that = this
                console.log(data)
                let venderstr = ''
                let mailstr = ''
                for(let i=0;i<data.length;i++){
                    venderstr = venderstr+data[i].vender_code+','
                    mailstr = mailstr+data[i].Mail_Address+','
                }
                that.dataVenderRFQ.Vender_Code = venderstr.substring(0,venderstr.length-1)
                that.dataVenderRFQ.Vender_Email = mailstr.substring(0,mailstr.length-1)
            },
            selectManager(){
                let that = this;
                that.$refs.manager.clearInput(true);
            },
            getManager(data){
                let that = this
                console.log(data)
                that.dataVenderRFQ.Manager_Person = data.name
                that.dataVenderRFQ.Manager_PersonEmail = data.email
            },
            //批量更新问题点
            upFRQQT(){
                let item = {
                    label: this.$t("getapi[12957]"),
                    name: 'upfrqqt',
                    path: '/upfrqqt',
                    url: '/upfrqqt',
                    icon: 'video-play'
                };
                this.$router.push({path: '/upfrqqt'});
                this.$store.commit('selectMenu', item);
            },
            // 设置有效期
            setEffectTime(){
                let that = this
                that.showEffectTime = true
            },
            confirmSetEffectTime(){
                let that = this
                let list = {
                    configname: "Purrfqbpart_EffectiveDate",
                    configtype: "Purrfqbpart_EffectiveDate",
                    configvalue:that.effectivedate,
                    module: "供应商开发",
                    old_configtype:"Purrfqbpart_EffectiveDate",
                    remarks: "采购询报价-基础零件有效期设置",
                }
                let arr = [];
                arr = [...arr, list];
                let parm = arr;
                that.$http.urlpost('/Sys/Currency/SaveSysConfig', parm, function(res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[1194]'));
                        that.showEffectTime=false;
                    }
                });
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
        margin-bottom: 5px!important;
    }
</style>
